import H3 from '@sdk/components/ui/typography/H3';
import Text16 from '@sdk/components/ui/typography/Text16';
import Column from '@sdk/components/ui/spacing/Column';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import AnimatedRow from '@kiosk/common/components/Forms/AnimatedRow';
import Button from '@kiosk/common/components/Button';
import ButtonContainer from '@kiosk/common/components/Forms/ButtonContainer';
import { DELAY } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/SelectAutomatedBreakView/selectAutomatedBreakView.constants';
import { useBackTooSoonView } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/BackTooSoonView/backTooSoonView.hooks';
import { Container } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/BackTooSoonView/backTooSoonView.styles';

const BackTooSoonView = () => {
  const { duration, colors, setAutomatedBreakScreen } = useBackTooSoonView();

  return (
    <Container>
      <AnimatedRow noPaddingHorizontal delay={DELAY}>
        <Column pBottom={10}>
          <H3 themeColor={ThemeColorType.primaryText} bold pBottom={10}>
            You are back too soon!
          </H3>
          <Text16
            color={`${colors.primaryText}99`}
            bold>{`Your break is scheduled to last ${duration} minutes.`}</Text16>
        </Column>
      </AnimatedRow>

      <ButtonContainer delay={0.4}>
        <Button
          label="Back"
          buttonTheme={'grey'}
          onPress={() => setAutomatedBreakScreen('clockedIn')}
        />
      </ButtonContainer>
    </Container>
  );
};

export default BackTooSoonView;
